/**
 * "从模板新建"的选择流程：usePersistence 在无 ?id 且已登录时调用 requestTemplateChoice()，
 * TemplatePicker 订阅 open 状态弹窗，用户选择后 resolve。模式同 api/auth.ts 的 requestLogin。
 */
import { create } from 'zustand';

export type TemplateChoice =
  | { kind: 'blank' }
  | { kind: 'template'; templateId: string; vars: Record<string, string>; title?: string };

interface TemplateState {
  open: boolean;
  resolvers: ((c: TemplateChoice) => void)[];
  request(): Promise<TemplateChoice>;
  finish(choice: TemplateChoice): void;
}

export const useTemplateStore = create<TemplateState>((set, get) => ({
  open: false,
  resolvers: [],
  request() {
    return new Promise<TemplateChoice>((resolve) => {
      set((s) => ({ open: true, resolvers: [...s.resolvers, resolve] }));
    });
  },
  finish(choice) {
    const { resolvers } = get();
    set({ open: false, resolvers: [] });
    resolvers.forEach((r) => r(choice));
  },
}));

export function requestTemplateChoice(): Promise<TemplateChoice> {
  return useTemplateStore.getState().request();
}
